export { default } from './TribeCard';
